import { PhysicalAttackSkill, StatusSkill } from "../../core/skill";
import { Effect, RoundEffect } from "../../core/effect";
import { Timing } from "../../core/timing";

import * as type from "../../core/type";
import * as cond from "../../core/cond";
import * as effect from "../../core/effect";
import * as state from "../../core/state";

export const 圣世惩杀 = new PhysicalAttackSkill(
    "圣世惩杀",
    type.圣灵·自然,
    [
        "消除对手的回合类效果，消除成功则使对手随机2个技能pp值归零",
        "消除对手的能力提升，消除成功则使自身在本场战斗中使用技能触发<span style='color: #33c0ed; font-weight: bold;'>星皇之怒</span>的基础概率提升10%",
        "<span style='color: #33c0ed; font-weight: bold;'>星皇之怒</span>：若对手不处于能力提升状态，则附加对手最大体力的1/3的百分比伤害",
    ],
    80,
    [
        new Effect(
            new effect.消除回合(),
            Timing.onDamage,
            undefined,
            [
                // TODO
            ],
        ),
        new Effect(
            new effect.消除强化(),
            Timing.onDamage,
            undefined,
            [
                // TODO
            ],
        ),
    ],
    3,
    false,
    1,
    5
);

export const 瀚空之门 = new StatusSkill(
    "瀚空之门",
    [
        "使己方免疫下2次异常状态",
        "使自身下2次受到的攻击伤害降低50%",
        "3回合内，若对手使用属性技能则减少对手所有技能3点pp值",
        "3回合内，若对手使用攻击技能则立即减少其最大体力的1/3",
        "<span style='color: #33c0ed; font-weight: bold;'>星皇之怒</span>：2回合内，自身的回合类效果无法被消除",
    ],
    [],
    0,
    5
);

export const 命宇轮回 = new StatusSkill(
    "命宇轮回",
    [
        "全属性+1，体力低于1/2使强化效果翻倍",
        "4回合内，每回合吸取对手最大体力的1/3，体力低于1/2时吸取效果翻倍",
        "自身下2次使用技能必定触发<span style='color: #33c0ed; font-weight: bold;'>星皇之怒</span>",
        "下2回合自身所有技能先制+2",
        "<span style='color: #33c0ed; font-weight: bold;'>星皇之怒</span>：下2回合造成的伤害提升100%",
    ],
    [],
    0,
    5
);

export const 亘古圣辰诀 = new PhysicalAttackSkill(
    "亘古圣辰诀",
    type.圣灵·自然,
    [
        "造成的伤害不低于280",
        "若造成的伤害等于280，则100%令对手疲惫",
        "当回合未击败对手，则使对手下1回合攻击技能无效",
        "<span style='color: #33c0ed; font-weight: bold;'>星皇之怒</span>：2回合内，对手的属性技能无效",
    ],
    150,
    [],
    1,
    false,
    1,
    5
);

export const 万皇宗魄诀 = new PhysicalAttackSkill(
    "万皇宗魄诀",
    type.圣灵·自然,
    [
        "若打出致命一击，则使自身在本场战斗中使用技能触发<span style='color: #33c0ed; font-weight: bold;'>星皇之怒</span>的基础概率提升10%",
        "当回合未击败对手，则下1回合附加350点固定伤害",
        "<span style='color: #33c0ed; font-weight: bold;'>星皇之怒</span>：2回合内，对手的魂印效果无效",
    ],
    160,
    [],
    0,
    true,
    10,
    5
);
